import React from 'react';
import { colors } from '@atlaskit/theme';
import Button from '@atlaskit/button';
import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import { borderRadius } from '@/styles';

import { SearchableType } from '../types';

const rootStyles = css`
  background-color: transparent !important;
`;

const tagStyles = css`
  display: flex;
  padding: 0px 6px 1px;
  margin: 4px;
  background-color: ${token('color.background.neutral', colors.N30)};
  color: ${token('color.text.subtle', colors.N600)};
  ${borderRadius};
  cursor: pointer;
`;

type ScopeProps = {
  scope: SearchableType;
} & Pick<React.HTMLProps<HTMLDivElement>, 'onClick'>;

const Scope: React.FC<ScopeProps> = ({ scope, onClick }: ScopeProps) => (
  <Button appearance="subtle" spacing="none" onClick={onClick} css={rootStyles}>
    <span css={tagStyles}>{`${scope}: `}</span>
  </Button>
);

export default Scope;
